import { appDeepSearchApi } from "../../config/apiConfig";
import type {
  TEventsResponse,
  TRequestTasksRun,
  TResearchResultResponse,
  TResponseTasksRun,
} from "./types";

export const createResearchRun = (
  postObj: TRequestTasksRun,
): Promise<TResponseTasksRun> => {
  return appDeepSearchApi.post("", postObj).then((res) => res.data);
};

export const getEventLog = (id: string): Promise<TEventsResponse> => {
  return appDeepSearchApi.get(`/${id}/events`).then((res) => res.data);
};

export const getResearchResult = (
  id: string,
): Promise<TResearchResultResponse> => {
  return appDeepSearchApi.get(`/${id}/result`).then((res) => res.data);
};
